import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { LIGHT_BLUE, RED, WHITE } from '../../../../../styles/color';

export const ScrollContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  max-width: 100vw;
  overflow-x: auto;
  overflow-y: hidden;
  overflow-anchor: none;
  -webkit-overflow-scrolling: touch;
`;

export const Layout = styled.div`
  position: fixed;
  bottom: 0;
  background-color: ${LIGHT_BLUE};
  width: 100%;
  color: white;
  display: table;
  table-layout: fixed;
`;

export const Content = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin: 0px 0px 10px 0px;
`;

export const CategoryButton = styled.button`
  width: 100%;
  min-height: 44px;
  padding: 8px 4px;
  border: 0;
  border-radius: 4px;
  background-color: ${({ $active }) => ($active ? RED : "transparent")};
  color: ${({ $active }) => ($active ? WHITE : "#cccccc")};
  font: inherit;
  line-height: 1.2;
  overflow-wrap: anywhere;
  white-space: normal;
  cursor: pointer;
  margin-bottom: 4px;

  &:focus-visible {
    outline: 2px solid ${WHITE};
    outline-offset: -2px;
  }
`;

export const SubMenuPanel = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  align-items: stretch;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  background-color: #007acc;
`;

export const SubMenuPanelItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 0;
  min-height: 40px;
  box-sizing: border-box;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: ${({ $active }) => ($active ? RED : "transparent")};

  & > a {
    color: ${({ $active }) => ($active ? WHITE : "#cccccc")};
    text-decoration: none;
  }

  & > a > span {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & > a > span > span {
    font-size: 13px;
  }

  & img {
    width: 25px;
    height: 25px;
    object-fit: contain;
  }
`;

export const SubMenuItem = styled.div`
  display: block;
  flex: 1 0 50.5px;
  box-sizing: border-box;
  min-width: 50.5px;
  padding: 8px 3px;
`;

export const MenuLink = styled(Link)`
  color: white;
`;
